<template>
  <!-- INICIO NEW EVENT MOBILE -->
<div class="screen-container">
  
<div class="modal-body">
              <button v-for="evt in eventTypes" :key="evt.event_type_id" class="btn btn-sm btn-evento"
                  @click="selectNewEvent(evt.event_type_id)">
                  <img class="icono" :src="'/images/event_type_' + evt.event_type_id + '.png'"
                      :alt="evt.event_type || 'Event Icon'" :title="evt.event_type || 'Evento'">
              </button>
              <div class="row d-flex align-items-center mb-1">
                    <div class="col-12 mb-1">
                        <label>Comentario</label>
                    </div>

                    <div class="col-12">
                        <textarea class="form-control" id="exampleFormControlTextarea1" style="height: 100px"
                            v-model="descript"></textarea>
                    </div>
              </div>

              <div class="w-100 mt-3">
                    <media-capture-uploader ref="mediaUploaderRef" :show-upload-button="false" :destPath="destPath"
                        v-if="globalStore.isMobile" />
                    <file-uploader v-else ref="fileUploaderRef" :show-upload-button="false" :destPath="destPath" />
              </div>
              <div class="row mt-3">
                    <div class="col-12 justify-content-end d-flex">
                        <button class="btn btn-secondary col-3" id="newEvent-volver" @click=""><i
                                class="bi bi-left-arrow"></i>
                            Volver
                        </button>
                        <button class="btn btn-danger" id="cancelar" @click="cancelar"
                            :disabled="isSaving">Cancelar</button>
                        <button class="btn btn-success" id="aceptar" @click="saveEvent" :disabled="isSaving">
                            <span v-if="isSaving">
                                <i class="bi bi-arrow-repeat spin"></i> Guardando...
                            </span>
                            <span v-else>
                                Aceptar
                            </span>
                        </button>
                    </div>
              </div>
              


              <!-- Ventana mobile 1/2
            <div class="modal-body" v-if="false">
                <div class="row d-flex align-items-center mb-1">
                    <div class="col-12">
                        <label>Creación</label>
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-2">
                    <div class="col-12">
                        <input class="form-control form-control-sm" type="date" id="creacion_fecha" v-model="fecha">
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-3">
                    <div class="col-9">
                        <input class="form-control form-control-sm" type="time" id="creacion_hora" v-model="hora">
                    </div>

                    <div class="col-3">
                        <button class="btn btn-secondary btn-sm" id="ahora" @click="setAhora">Ahora</button>
                    </div>
                </div>    
                 <div class="row d-flex align-items-center mb-1">
                    <div class="col-12">
                        <label>Tipo</label>
                    </div>
                    </div>
                <div class="row d-flex align-items-center mb-2">
                    <div class="col-12">
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="eventTypeSelected">
                            <option v-for="tipo in eventTypes" :key="tipo.event_type_id"
                                :value="{ id: tipo.event_type_id, text: tipo.event_type }">{{
                                    tipo.event_type
                                }}</option>
                        </select>
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-3">
                    <div class="col-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                v-model="visible">
                            <label class="form-check-label" for="flexCheckDefault">
                                Visible
                            </label>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                v-model="dynamic">
                            <label class="form-check-label" for="flexCheckDefault">
                                Dinámico
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-1">
                    <div class="col-12">
                        <label>Alcance</label>
                    </div>
                </div>
                
                <div class="row d-flex align-items-center mb-3">
                    <div class="col-12">
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="selectedScope">
                            <option v-for="alc in alcances" :key="alc">{{ alc }}</option>
                        </select>
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-3">
                    <div class="col-12">
                        <label>Estado</label>
                    </div>
                    <div class="col-12">
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="selectedState">
                            <option v-for="est in estados" :key="est">{{ est }}</option>
                        </select>
                    </div>
                </div>

                <div class="row d-flex align-items-center mb-1">
                    <div class="col-12 mb-2">
                        <label>Ubicación</label>
                    </div>

                    <div class="col-3 mb-1">
                        <label>Lat</label>
                    </div>

                    <div class="col-9">
                        <input class="form-control form-control-sm" type="text" id="lat" v-model="lat">
                    </div>

                    <div class="col-3">
                        <label>Lon</label>
                    </div>

                    <div class="col-9 mb-2">
                        <input class="form-control form-control-sm" type="text" id="lon" v-model="lon">
                    </div>

                    <div class="col-12">
                        <button class="btn btn-secondary btn-sm col-12" id="pasteCoords" @click="pasteCoords"><i
                                class="bi bi-pin-map-fill"></i></button>
                    </div>
                </div>
                <div class="col-12">
                        <button class="btn btn-secondary btn-sm col-12" id="newEvent-siguiente" @click=""><i
                                class="bi bi-right-arrow"></i> Siguiente</button>
                    </div>
            </div>
            <!-- Ventana mobile 2/2 -->
            <!-- <div class="modal-body" v-if="true"> 
                 <div class="row d-flex align-items-center mb-1">
                    <div class="col-12 mb-1">
                        <label>Comentario</label>
                    </div>

                    <div class="col-12">
                        <textarea class="form-control" id="exampleFormControlTextarea1" style="height: 100px"
                            v-model="descript"></textarea>
                    </div>
                </div>

                <div class="w-100 mt-3">
                    <media-capture-uploader ref="mediaUploaderRef" :show-upload-button="false" :destPath="destPath"
                        v-if="globalStore.isMobile" />
                    <file-uploader v-else ref="fileUploaderRef" :show-upload-button="false" :destPath="destPath" />
                </div>
                <div class="row mt-3">
                    <div class="col-12 justify-content-end d-flex">
                        <button class="btn btn-secondary col-3" id="newEvent-volver" @click=""><i
                                class="bi bi-left-arrow"></i>
                            Volver
                        </button>
                        <button class="btn btn-danger" id="cancelar" @click="cancelar"
                            :disabled="isSaving">Cancelar</button>
                        <button class="btn btn-success" id="aceptar" @click="saveEvent" :disabled="isSaving">
                            <span v-if="isSaving">
                                <i class="bi bi-arrow-repeat spin"></i> Guardando...
                            </span>
                            <span v-else>
                                Aceptar
                            </span>
                        </button>
                    </div>
                </div>

            </div> -->





</div></div>

<!-- FIN NEW EVENT MOBILE -->
</template>
<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import { useServicesStore } from '@/stores/services';
import { storeToRefs } from 'pinia';
import type { APIResponse, EventType, NewEventData, NewEventInput, NewEventResponse } from '@/types';
import { estados, alcances } from '@/staticData';
import API from "../services";
import { AxiosError } from "axios";
import BaseModal from './base/BaseModal.vue'
import { useAuthStore } from '../stores/t-auth'
import FileUploader from './FileUploader.vue';
import { useUtils } from '@/composables/useUtils';
import { useGlobalStore } from '@/stores/global';
import MediaCaptureUploader from './MediaCaptureUploader.vue';

/**
 * Returns the MIME type for a given file extension.
 */
function getMimeTypeFromExtension(ext: string): string {
    const map: Record<string, string> = {
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'bmp': 'image/bmp',
        'webp': 'image/webp',
        'mp4': 'video/mp4',
        'mov': 'video/quicktime',
        'avi': 'video/x-msvideo',
        'mkv': 'video/x-matroska',
        'mp3': 'audio/mpeg',
        'wav': 'audio/wav',
        'ogg': 'audio/ogg',
        'pdf': 'application/pdf',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'txt': 'text/plain',
        'zip': 'application/zip',
        'rar': 'application/vnd.rar'
    };
    return map[ext.toLowerCase()] || 'application/octet-stream';
}



const props = defineProps<{
    newEventData: NewEventData
}>()

const datos = useServicesStore();
const globals = useGlobalStore();
const { eventTypes } = storeToRefs(datos);
const destPath = ref(''); // Define destPath as a reactive reference

const emit = defineEmits<{
    (event: 'close'): void,
    (event: 'buttonSelected', datos: NewEventData): void,
    (event: 'center-map', coords: [number, number]): void
}>()

function selectNewEvent(eventTypeId: number) {
    let datos: NewEventData = {
        event_type_id: eventTypeId,
        lat: props.newEventData.lat,
        lon: props.newEventData.lon
    }
    emit('buttonSelected', datos)
}

function copyCoordinates() {
    const lat = props.newEventData.lat
    const lon = props.newEventData.lon
    const coordinates = `${lat}, ${lon}`

    // Guardar en el store global
    globals.copyCoordinatesToClipboard(lat, lon, 'NewEventSelector')

    // Copiar al clipboard del sistema
    navigator.clipboard.writeText(coordinates).then(() => {
        console.log('Coordenadas copiadas al sistema y guardadas globalmente:', coordinates)
        // Cerrar la ventana después de copiar exitosamente
        closeDialog()
    }).catch(err => {
        console.error('Error al copiar coordenadas al sistema:', err)
        // Fallback para navegadores que no soportan clipboard API
        const textArea = document.createElement('textarea')
        textArea.value = coordinates
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        console.log('Coordenadas copiadas (fallback) y guardadas globalmente:', coordinates)
        // Cerrar la ventana después de copiar con fallback
        closeDialog()
    })
}

function closeDialog() {
    console.log('Cerrando NewEventSelector')
    emit('close')
}

// Función para manejar tecla Escape
function handleEscKey(event: KeyboardEvent) {
    if (event.key === 'Escape') {
        console.log('Escape presionado')
        closeDialog()
    }
}

onMounted(() => {
    console.log('NewEventSelector montado')
    document.addEventListener('keydown', handleEscKey)
})

onUnmounted(() => {
    console.log('NewEventSelector desmontado')
    document.removeEventListener('keydown', handleEscKey)
})


// Crear la referencia del template
const fileUploaderRef = ref<InstanceType<typeof FileUploader> | null>(null);
// Crear la referencia del template para MediaCaptureUploader
const mediaUploaderRef = ref<InstanceType<typeof MediaCaptureUploader> | null>(null);

// Definiciones de variables y referencias
const auth = useAuthStore()

const globalStore = useGlobalStore();
const { coordinatesClipboard } = storeToRefs(globalStore);

const state = ref(estados)

const fecha = ref('')
const hora = ref('')
const lat = ref(0)
const lon = ref(0)
const eventTypeSelected = ref({ id: 0, text: "" })
const selectedScope = ref("LOCAL")
const selectedState = ref("ACTIVO")
const visible = ref(false)
const dynamic = ref(false)
const descript = ref("")
const isSaving = ref(false);

onMounted(async () => {
    lat.value = props.newEventData.lat
    lon.value = props.newEventData.lon
    let tipoEvento = eventTypes.value.find(tipo => tipo.event_type_id === props.newEventData.event_type_id)
    if (tipoEvento) {
        eventTypeSelected.value = { id: tipoEvento.event_type_id, text: tipoEvento.event_type }
    }
})


let ahora = new Date()


async function saveEvent() {
    isSaving.value = true;
    console.log('Guardando evento...')
    let unitId = "AW";
    let mission = 0;
    if (globalStore.patrulla.unitId && globalStore.patrulla.unitId !== "") {
        unitId = globalStore.patrulla.unitId.substring(0, 2);
        mission = globalStore.patrulla.activeMission;
    }
    let input = {
        record_unit: unitId,
        utc: fecha.value + ' ' + hora.value,
        event_number: 1,
        event_unit: unitId,
        type: eventTypeSelected.value.text,
        description: descript.value,
        mission: mission,
        reference: 0,
        location_lat: lat.value,
        location_lon: lon.value,
        state: selectedState.value,
        scope: selectedScope.value,
        visible: (visible.value) ? 1 : 0,
        data: descript.value,
        json: "",
        user_id: auth.logedUser,
    }

    try {
        const { status, data } = await API.postEvent(input);

        if (status === 200) {
            const nuevoEvento = {
                event_id: data.Entries.Entry[0].event_id,
                record_number: data.Entries.Entry[0].record_number,
                record_unit: input.record_unit,
                utc: input.utc,
                event_number: data.Entries.Entry[0].record_number,
                event_unit: input.event_unit,
                type: input.type,
                description: input.description,
                mission: input.mission,
                reference: input.reference,
                location: {
                    type: "Point",
                    coordinates: [input.location_lon, input.location_lat] as [number, number]
                },
                state: input.state,
                scope: input.scope,
                user_visible: 1,
                data: input.data,
                json: input.json,
                user_id: input.user_id,
            };

            // Agregar el evento al inicio del array global
            datos.eventsPropios.unshift(nuevoEvento);

            // Obtener el año y el mes actuales
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = String(now.getMonth() + 1).padStart(2, '0'); // Mes en formato "MM"

            destPath.value = '/events/' + currentYear + '/' + currentMonth + '/' + unitId + nuevoEvento.record_number;
            // Subir archivos si hay alguno seleccionado
            if (globalStore.isMobile) {
                if (mediaUploaderRef.value && mediaUploaderRef.value.files.length > 0) {
                    try {
                        const uploadResults = await mediaUploaderRef.value.uploadAllFiles();
                        for (const fileItem of mediaUploaderRef.value.files) {
                            if (fileItem.status === 'success') {
                                const file = fileItem.file;
                                const attachmentInput = {
                                    event_id: nuevoEvento.event_id,
                                    utc: nuevoEvento.utc,
                                    file_name: file.name,
                                    file_path: destPath.value + '/' + file.name,
                                    mime_type: getMimeTypeFromExtension(file.name.split('.').pop() || ''),
                                    file_ext: file.name.split('.').pop() || '',
                                    user_id: auth.logedUser,
                                };
                                try {
                                    await API.createEventAttachment(attachmentInput);
                                    console.log(`Archivo ${file.name} asociado al evento correctamente.`);
                                } catch (error) {
                                    console.error(`Error al asociar el archivo ${file.name}:`, error);
                                }
                            }
                        }
                    } catch (error) {
                        console.error('Error al subir archivo multimedia:', error);
                    }
                }
            } else {
                // Modo escritorio: FileUploader
                if (fileUploaderRef.value && fileUploaderRef.value.files.length > 0) {
                    try {
                        const now = new Date();
                        const currentYear = now.getFullYear();
                        const currentMonth = String(now.getMonth() + 1).padStart(2, '0');
                        destPath.value = '/events/' + currentYear + '/' + currentMonth + '/' + unitId + nuevoEvento.record_number;

                        await fileUploaderRef.value.uploadAllFiles();
                        for (const file of fileUploaderRef.value.files) {
                            const attachmentInput = {
                                event_id: nuevoEvento.event_id,
                                utc: nuevoEvento.utc,
                                file_name: file.file.name,
                                file_path: destPath.value + '/' + file.file.name,
                                mime_type: getMimeTypeFromExtension(file.file.name.split('.').pop() || ''),
                                file_ext: file.file.name.split('.').pop() || '',
                                user_id: auth.logedUser,
                            };

                            try {
                                await API.createEventAttachment(attachmentInput);
                                console.log(`Archivo ${file.file.name} asociado al evento correctamente.`);
                            } catch (error) {
                                console.error(`Error al asociar el archivo ${file.file.name}:`, error);
                            }
                        }
                    } catch (error) {
                        console.error('Error al subir archivos:', error);
                    }
                }
            }

            emit('center-map', [nuevoEvento.location.coordinates[0], nuevoEvento.location.coordinates[1]])
            emit('close')
            console.log('Evento y archivos guardados OK: ')
        }
    } catch (error) {
        const _error = error as AxiosError<string>;
        emit('close')
        console.log('Error: ' + _error)
    } finally {
        isSaving.value = false; // Habilita el botón si ocurre error o al finalizar
    }
}
function cancelar() {
    emit('close')
}
function setAhora() {
    const ahora = new Date();
    fecha.value = ahora.toISOString().split('T')[0];
    hora.value = ahora.toISOString().split('T')[1].split('.')[0];
}
function pasteCoords() {
    if (coordinatesClipboard.value) {
        lat.value = coordinatesClipboard.value.lat;
        lon.value = coordinatesClipboard.value.lon;
    }
}
</script>

<style lang="css" scoped>
.modal-body {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    padding-top: 10px;
    justify-content: center;
    z-index: 2000;
}

.btn-evento {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    border-radius: 5px;
    background-color: #f0f0f0;
    cursor: pointer;
    transition: background-color 0.2s;
}

.btn-evento:hover {
    background-color: #e0e0e0;
}

.icono {
    width: 32px;
    height: 32px;
}

.separator {
    width: 100%;
    margin: 5px 0;
    border: 0;
    height: 1px;
    background-color: #dee2e6;
}

.coordinates-section {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
}

.btn-coordinates {
    background-color: #dee2e6;
    color: rgb(0, 0, 0);
    border: 1px solid #dee2e6;
    padding: 8px 16px;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.btn-coordinates:hover {
    background-color: #686868;
    border-color: #686868;
    color: white;
    border: 2px solid white;
}

.btn-coordinates:active {
    transform: scale(0.98);
}

h4 {
    text-align: center;
    font-size: medium;
}

.col-4, .col-2 {
    display: flex;
    justify-content: center;
    align-items: center;
}


.modalr {
    position: fixed;
    top: 350px;
    left: 350px;
    z-index: 15;

}

.modal-body {
    padding-left: 10px;
}

.screen-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(50, 50, 50, 0.8);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 2000;
  overflow: hidden;
  color: white;
}


@media (max-width: 576px) {
    label {
        font-size: 1em;
        margin-bottom: 5px;
    }
    .modal-container {
        min-width: calc(100% - 20px);
        width: calc(100% - 20px);
    }
    .col-12 .form-select-sm {
        width: 100%;
    }
    .form-check .form-check-input {
        height: 1.5em;
        width: 1.5em;
    }
    .form-check-label{
        font-size: 1em;
        margin-left: 1em;
    }

}

.spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

</style>